"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var PlotBand_1 = require("../PlotBand");
var PlotLine_1 = require("../PlotLine");
function default_1(base, yAxisElements) {
    var options = [];
    var chartDefaults = {
        gridLineWidth: 1.5,
        opposite: false,
        title: { text: '', useHTML: true },
        labels: { useHTML: true }
    };
    if (base.chartType === 'gantt') {
        chartDefaults.grid = { borderWidth: 0 };
    }
    var colors = utils_1.chartColors(base.colors);
    if (yAxisElements && yAxisElements.length) {
        options = yAxisElements.map(function (yAxisElement) {
            var gaugeVariant = {
                min: 0,
                max: 100,
                lineWidth: 0,
                gridLineWidth: 0,
                tickWidth: 0,
                minorTickWidth: 0,
                labels: { enabled: false }
            };
            var yAxisOptions = {};
            var _a = yAxisElement.props, children = _a.children, labelPrefix = _a.labelPrefix, labelSuffix = _a.labelSuffix, showGridLines = _a.showGridLines, variant = _a.variant, overrides = __rest(_a, ["children", "labelPrefix", "labelSuffix", "showGridLines", "variant"]);
            var _b = utils_1.typeChildren(children), plotBands = _b.plotBands, plotLines = _b.plotLines;
            yAxisOptions = __assign(__assign({}, variant === 'gauge' && gaugeVariant), overrides);
            yAxisOptions.labels = __assign(__assign(__assign({}, chartDefaults.labels), { format: (labelPrefix || '') + "{value}" + (labelSuffix || '') }), yAxisOptions.labels);
            if (plotBands) {
                yAxisOptions.plotBands = PlotBand_1.plotBandOptions(plotBands, colors);
            }
            if (plotLines) {
                yAxisOptions.plotLines = PlotLine_1.plotLineOptions(plotLines, colors);
            }
            if (typeof yAxisOptions.title === 'string') {
                yAxisOptions.title = __assign(__assign({}, chartDefaults.title), { text: yAxisOptions.title });
            }
            if (showGridLines === false) {
                yAxisOptions.gridLineWidth = 0;
            }
            return __assign(__assign({}, chartDefaults), yAxisOptions);
        });
    }
    else {
        options.push(chartDefaults);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=yAxisOptions.js.map